import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.type"],
  (action: any): any => action
);
